import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBxj7rTfg5894tqYeMKH-UnfT253P4DCDI",
  authDomain: "trumper-2021.firebaseapp.com",
  projectId: "trumper-2021",
  storageBucket: "trumper-2021.appspot.com",
  messagingSenderId: "530723620522",
  appId: "1:530723620522:web:cc883bd11e0244e8d632d3",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;
